
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class NotificationPopup extends Vue {
  @Prop(Array) readonly items!: any[];

  statusClass(status: string) {
    switch (status) {
      case "WARNING":
        return "text-yellow-500 text-2xl mdi mdi-alert";
      case "ERROR":
        return "text-red-500 text-2xl mdi mdi-close-octagon-outline";
      default:
        return `text-green-500 text-2xl mdi mdi-checkbox-marked-circle-outline`;
    }
  }
}
